import React, {useEffect, useRef, useState} from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {classNames} from "primereact/utils";
import {Badge} from "primereact/badge";
import {Button} from "primereact/button";
import 'react-h5-audio-player/lib/styles.css';
import {Dialog} from "primereact/dialog";
import {
    getEventMonitorToUserDetail, getMonitoringQueueList,
} from "../../../redux/api/apiMonitoringList";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {
    getMonitoringQueue, setCurrentMonitoringQueuePage, setCurrentMonitoringQueuePageSize,
    setCurrentPage,
    setCurrentPageSize, setQueueMonitorStats,
} from "../../../redux/actions/actionsMonitoringList";
import {MultiSelect} from "primereact/multiselect";
import {DataRow, DecodedToken} from "../../../types/types";
import {jwtDecode} from "jwt-decode";
import {setStatisticsCurrentPage} from "../../../redux/actions/actionsStatisticsList";
import MonitoringQueueNav from "./MonitoringQueueNav";
import MonitoringQueueDetails from "./MonitoringQueueDetails";

const filteredColumns = [
    {
        "name": "callType",
        "order": 1,
        "isActive": true,
        "inSystem": false
    },
    {
        "name": "direction",
        "order": 2,
        "isActive": true,
        "inSystem": false
    },
    {
        "name": "queueFullName",
        "order": 3,
        "isActive": true,
        "inSystem": false
    },
    {
        "name": "ani",
        "order": 4,
        "isActive": true,
        "inSystem": true
    },
    {
        "name": "contactName",
        "order": 5,
        "isActive": true,
        "inSystem": false
    },
     {
         name: "aNumber",
         order: 6,
         isActive: true,
         inSystem: false
     },
     {
        "name": "ownerUserName",
        "order": 7,
        "isActive": true,
        "inSystem": false
    },
    {
        "name": "ownerType",
        "order": 8,
        "isActive": true,
        "inSystem": false
    },
    {
        "name": "start",
        "order": 9,
        "isActive": true,
        "inSystem": false
    }
];

const MonitoringQueue = (props: any) => {
    const dispatch = useAppDispatch();
    const monitoringList = useAppSelector(state => state.MonitoringListReducer?.monitoringQueueList);
    const newMonitoringQueueList = useAppSelector(state => state.MonitoringListReducer?.newMonitoringQueueList);
    // @ts-ignore
    const queueMonitorStats = useAppSelector(state => state.MonitoringListReducer?.queueMonitorStats);
    const userSortFields: any = useAppSelector(state => state.RolesReducer.userSortFields);
    const campaignList = useAppSelector(state => state.MonitoringListReducer?.campaignListName);
    const loader = useAppSelector(state => state.MonitoringListReducer.monitoringQueueLoader);
    const statusDictionary = useAppSelector(state => state.MonitoringListReducer.statusDictionary);
    const callResetDictionary = useAppSelector(state => state.MonitoringListReducer.callResetDictionary);
    const forcedClosingDictionary = useAppSelector(state => state.MonitoringListReducer.forcedClosingDictionary);
    const ownerTypeDictionary = useAppSelector(state => state.MonitoringListReducer.ownerTypeDictionary);
    const callTypeDictionary = useAppSelector(state => state.MonitoringListReducer.callTypeDictionary);
    const clearFilters = useAppSelector(state => state.MonitoringListReducer.clearFilters)
    const user = useAppSelector(state => state.UsersReducer.userData);
    // @ts-ignore
    const activeClick = useAppSelector(state => state.UsersListReducer.activeClick);
    const [first, setFirst] = useState(0);
    const [selectedRowData, setSelectedRowData] = useState<any | null>(null);
    const [selectedRowExpansion, setSelectedRowExpansion] = useState<any | null>(null);
    const [selectedSessionRowExpansion] = useState<any | null>(null);
    const [selectedBSessionRowExpansion] = useState<any | null>(null);
    const [orderBy, setOrderBy] = useState<any>(null);
    const [isDescFilter, setIsDescFilter] = useState<boolean>(true);
    const [sortOrder, setSortOrder] = useState<number>(0);
    const [startTime, setStartTime] = useState<any>(null);
    const [endTime, setEndTime] = useState<any>(null);
    const [filterDateTime, setFilterDateTime] = useState<any>(false);
    const [filterEndDateTime, setFilterEndDateTime] = useState<any>(false);
    const [visible, setVisible] = useState(false);
    const spyCallAnsweredTick = useAppSelector(state => state.WebRTCReducer.spyCallAnsweredTick);
    const [activeTab, setActiveTab] = useState<string>('table1');
    const dataTableRef = useRef<DataTable | any>(null);
    // @ts-ignore
    const queuesDirectoryDirectionType = useAppSelector(state => state.QueueListReducer.queuesDirectoryDirectionType) as any;
    const [expandedRows, setExpandedRows] = useState<any>([]);
    const [expandedSessionRows, setExpandedSessionRows] = useState<any>([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    // @ts-ignore
    const [selectedColumns, setSelectedColumns] = useState<any>(filteredColumns?.filter((item: { isActive: any; }) => item.isActive));
    const pageChanged = useAppSelector(state => state.MonitoringListReducer.pageChanged);
    const [activity, setActivity] = useState<any>(false);
    const [toggleButtonActivity, setToggleButtonActivity] = useState<any>(false);

    let decodedToken: DecodedToken;
    if (jwtToken?.jwtToken) {
        decodedToken = jwtDecode(jwtToken?.jwtToken);
    }

    function mergeMonitoringQueue(current: any, payload: any) {
        const Add = Array.isArray(payload?.add) ? payload.add : [];
        const Del = Array.isArray(payload?.del) ? payload.del : [];

        const delIds = new Set(Del.map((x: { callDetailId: any; }) => x.callDetailId));

        if (selectedRowData && delIds.has(selectedRowData?.callDetailId)) {
            setSelectedRowData(null);
        }

        const updated = (current || []).filter(
            (item: { callDetailId: any; }) => !delIds.has(item.callDetailId)
        );

        for (const addItem of Add) {
            const exists = updated.some((i: { callDetailId: any; }) => i.callDetailId === addItem.callDetailId);
            if (!exists) {
                updated.push(addItem);
            }
        }

        return updated;
    }

    useEffect(() => {
        if (!newMonitoringQueueList) return;

        if (newMonitoringQueueList.CountActiveCalls !== undefined && newMonitoringQueueList.WithNotification !== undefined) {
            dispatch(setQueueMonitorStats({
                countActiveCalls: newMonitoringQueueList.CountActiveCalls,
                withNotification: newMonitoringQueueList.WithNotification
            }));
        }

        const updated = mergeMonitoringQueue(monitoringList, keysFirstLetterToLowerCase(newMonitoringQueueList));
        dispatch(getMonitoringQueue(updated));
    }, [newMonitoringQueueList]);

    useEffect(() => {
        if (selectedRowData && monitoringList) {
            const stillExists = monitoringList.some((item: any) => item.sessionId === selectedRowData.sessionId);
            if (!stillExists) {
                setSelectedRowData(null);
                setSelectedRowExpansion(null);
            }
        }
    }, [monitoringList, selectedRowData]);

    useEffect(() => {
        if (spyCallAnsweredTick) {
            setVisible(false);
        }
    }, [spyCallAnsweredTick]);

    function keysFirstLetterToLowerCase(obj: any): any {
        if (Array?.isArray(obj)) {
            return obj.map(item => keysFirstLetterToLowerCase(item));
        } else if (obj !== null && typeof obj === 'object') {
            return Object.keys(obj).reduce((acc: any, key: string) => {
                const firstLetterLowerCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
                acc[firstLetterLowerCaseKey] = keysFirstLetterToLowerCase(obj[key]);
                return acc;
            }, {});
        }
        return obj;
    }

    const resetTableHorizontalScroll = () => {
        const scrollableBody = document.querySelector('.p-datatable-wrapper');
        if (scrollableBody) {
            scrollableBody.scrollTop = 0;
            scrollableBody.scrollLeft = 0;
        }
    };

    useEffect(() => {
        setSelectedColumns(filteredColumns?.filter((item: { isActive: any; }) => item.isActive));
    }, []);

    useEffect(() => {
        setFirst(0);
    }, [pageChanged])

    useEffect(() => {
        setSelectedColumns(filteredColumns?.filter((item: { isActive: any; }) => item.isActive));
    }, [filteredColumns]);

    const createUuidv4 = () => {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
            // @ts-ignore
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    const formatDateTime = (dateString: any) => {
        const date = new Date(dateString);
        return `${date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit'})} ${date.toLocaleDateString('en-GB')}`;
    };

    const formatItem = (item: { start: any; }) => {
        if (item && item.start) {
            return {
                ...item,
                start: formatDateTime(item.start),
                dateTime: createUuidv4()
            };
        }
        return item;
    };

    const formatDataRecursively = (obj: any) => {
        const formattedObj = {
            ...obj,
            item: formatItem(obj.item),
        };

        if (formattedObj.children && formattedObj.children.length > 0) {
            formattedObj.children = formattedObj.children.map((child: any) => formatDataRecursively(child));
        }

        return formattedObj;
    };


    const handleReset = () => {
        dataTableRef?.current?.reset();
        customFilter();
        setStartTime(null);
        setEndTime(null);
        setFilterEndDateTime(null);
        setSortOrder(0);
        setFirst(0);
        dispatch(setCurrentPage(1));
        dispatch(setCurrentPageSize(10));
        setActivity(false);
    };

    useEffect(() => {
        dispatch(getMonitoringQueueList(jwtToken?.jwtToken));
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const onPageChange = (event: { first: React.SetStateAction<number>; page: number; rows: any; }) => {
        setFirst(event.first);
        dispatch(setCurrentMonitoringQueuePage(event.page + 1));
        dispatch(setCurrentMonitoringQueuePageSize(event.rows));
    };

    useEffect(() => {
        if (activeClick?.item === "/monitoring_queue" && activeClick?.from === '#/monitoring_queue') {
            dispatch(getMonitoringQueueList(jwtToken?.jwtToken));
            resetTableHorizontalScroll();
        }
    }, [activeClick]);

    const monitoringSort = (event: { sortField: any; }) => {
        const handleAction = (sortField: string) => {
            let newOrderBy: string;

            switch (sortField) {
                case 'item.userName':
                    newOrderBy = 'UserName';
                    break;
                case 'item.callType':
                    newOrderBy = 'CallType';
                    break;
                case 'item.start':
                    newOrderBy = 'Start';
                    break;
                case 'item.status':
                    newOrderBy = 'Status';
                    break;
                case 'item.ani':
                    newOrderBy = 'Ani';
                    break;
                case 'item.aNumber':
                    newOrderBy = 'ANumber';
                    break;
                case 'item.campaignName':
                    newOrderBy = 'CampaignName';
                    break;
                case 'item.campaignId':
                    newOrderBy = 'CampaignId';
                    break;
                case 'item.callReset':
                    newOrderBy = 'CallReset';
                    break;
                case 'forcedClosing':
                    newOrderBy = 'ForcedClosing';
                    break;
                case 'item.fullName':
                    newOrderBy = 'UserName';
                    break;
                case 'direction':
                    newOrderBy = 'Direction';
                    break;
                case 'item.queueId':
                    newOrderBy = 'QueueId';
                    break;
                case 'item.ownerUserName':
                    newOrderBy = 'OwnerUserName';
                    break;
                case 'FullCallDuration':
                    newOrderBy = 'FullCallDuration';
                    break;
                case 'Duration':
                    newOrderBy = 'Duration';
                    break;
                case 'ReactionOperator':
                    newOrderBy = 'ReactionOperator';
                    break;
                case 'ReactionClient':
                    newOrderBy = 'ReactionClient';
                    break;
                case 'End':
                    newOrderBy = 'End';
                    break;
                case 'OwnerType':
                    newOrderBy = 'OwnerType';
                    break;
                case 'ANumber':
                    newOrderBy = 'ANumber';
                    break;
                default:
                    return;
            }

            setOrderBy(newOrderBy);
            setIsDescFilter(!isDescFilter);
            setSortOrder(sortOrder === 1 ? -1 : 1);
            dispatch(setCurrentPage(1));
            setFirst(0);
        };
        let sortField = event.sortField;
        handleAction(sortField);
    };

    const filterClearTemplate = (options: { filterClearCallback: React.MouseEventHandler<HTMLButtonElement> | undefined; field: string }) => {
        return <Button type="button" className="p-button-secondary" icon="pi pi-times" onClick={(e) => {
            if (options.filterClearCallback) {
                options.filterClearCallback(e);
            }
            if (options.field === 'start') {
                setStartTime(null);
                setEndTime(null);
                setFilterDateTime(null);
                setFilterEndDateTime(null);
            }
        }}></Button>;
    }

    const filterApplyTemplate = (options: {
        filterApplyCallback: React.MouseEventHandler<HTMLButtonElement> | undefined;
        field: string;
    }) => {
        const handleClick = () => {
            if (options.filterApplyCallback) {
                options.filterApplyCallback({} as any);
            }
        };

        const isTimeValid = (startTime: Date | null | false, endTime: Date | null | false): boolean => {
            if (!startTime || !endTime) return true;
            return endTime.getTime() > startTime.getTime();
        };

        return <Button type="button" icon="pi pi-check" onClick={handleClick} className=""
                       disabled={
                           (options.field === 'start' && ((!filterDateTime || !filterEndDateTime) || !isTimeValid(startTime, endTime)))
                       }></Button>
    }

    const customFilter = (event?: any) => {
        if (event) {
            const filters = event.filters;
            const {start} = event.filters;
            const {end} = event.filters;

            setFirst(0);
            dispatch(setStatisticsCurrentPage(1));

            setFilterDateTime(start.value || null);

            const setFilter = (filterName: string, key: string, defaultValue?: any | null) => {
                if (!filters[filterName]) {
                    return defaultValue;
                }

                const value = filters[filterName].value || filters[filterName].constraints?.[0]?.value;
                if (!value) {
                    return defaultValue;
                }

                if (Array?.isArray(value)) {
                    return value.map((item) => ({key, value: String(item)}));
                } else {
                    return {key, value: String(value)};
                }
            };
        } else {
            setFilterDateTime(null);
            setOrderBy(null);
            setIsDescFilter(true);
        }
    };

    const renderHeader = (field: string, sortField: string) => {
        const sorted = sortField === orderBy;
        const sortIcon = classNames('p-sortable-column-icon', {
            'pi pi-sort-amount-up-alt': sorted && sortOrder === 1,
            'pi pi-fw pi-sort-amount-down': sorted && sortOrder === -1,
            'pi pi-fw pi-sort-alt': sortOrder === 0 || !sorted
        });

        return (
            <div className="flex align-items-center" onClick={() => monitoringSort({'sortField': sortField})}>
                {field} <i className={sortIcon}></i>
            </div>
        );
    };

    const toggleTab = (tableName: string) => {
        setSelectedRowData(null);
        setActiveTab(tableName);
    };

    const isMobile = () => {
        return windowWidth <= 1248;
    }

    const renderActivityColumn = ({item}: any) => {
        return item?.callType === 'transferInternal' && !item.isDeclined ? (
            <div className="relative">
                <i className="pi pi-reply p-2 bg-green-500 border-circle text-white"
                   style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
            </div>
        ) : item?.callType === 'transferInternal' && item.isDeclined ? (
                <div className="relative">
                    <i className="pi pi-reply p-2 bg-green-500 border-circle text-white"
                       style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
                    <div className="absolute" style={{top: '-5px', left: '18px'}}>
                        <div className="border-circle relative"
                             style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                            <i className="pi pi-times text-white absolute left-50 top-50 kk"
                               style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                        </div>
                    </div>
                </div>) :

            item?.callType === 'transferExternal' && !item.isDeclined ? (
                <div className="relative">
                    <i className="pi pi-reply p-2 bg-primary border-circle text-white"
                       style={{transform: 'rotate(90deg) scaleX(-1) scaleY(-1)'}}></i>
                </div>
            ) : item?.callType === 'transferInternal' && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-reply p-2 bg-primary border-circle text-white"
                           style={{transform: 'rotate(90deg) scaleX(-1) scaleY(-1)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>)
                : item?.callType === 'callback' ? (
                    <div className="relative">
                        <i className="pi pi-undo p-2 border-circle text-white" style={{backgroundColor: "#fda610"}}></i>
                    </div>
                ) : item?.callType === 'internal' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                    </div>
                ) : item?.callType === 'internal' && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'external' && !item.isDeclined ? (
                    <>
                        <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
                    </>
                ) : item?.callType === 'external' && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'ivm' && !item.isDeclined ? (
                    <>
                        <i className="bg-primary p-2 border-circle text-white font-bold relative"
                           style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                            className="absolute"
                            style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVM</span></i>
                    </>
                ) : item?.callType === 'ivm' && item.isDeclined ? (
                    <div className="relative inline-block">
                        <i className="bg-primary border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
                           style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                            style={{fontSize: '11px'}}>IVM</span></i>
                        <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : item?.callType === 'ivr' && !item.isDeclined ? (
                    <>
                        <i className="bg-green-500 p-2 border-circle text-white font-bold relative"
                           style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                            className="absolute"
                            style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVR</span></i>
                    </>
                ) : item?.callType === 'ivr' && item.isDeclined ? (
                    <div className="relative inline-block">
                        <i className="bg-green-500 border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
                           style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                            style={{fontSize: '11px'}}>IVR</span></i>
                        <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : item?.callType === 'callbackExternal' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-undo p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative bg-primary"
                                 style={{width: '14px', height: '14px'}}>
                                <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'callbackInternal' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-undo p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative bg-green-500"
                                 style={{width: '14px', height: '14px'}}>
                                <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : (item?.callType === 'callbackInternal' || item?.callType === 'callbackExternal') && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-undo p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'consultationExternal' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-users p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative bg-primary"
                                 style={{width: '14px', height: '14px'}}>
                                <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : item?.callType === 'consultationInternal' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-users p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative bg-green-500"
                                 style={{width: '14px', height: '14px'}}>
                                <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : (item?.callType === 'consultationInternal' || item?.callType === 'consultationExternal') && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-users p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'consultation' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-users p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                    </div>
                ) : (item?.callType === 'pickupcall') && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-user p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>) : item?.callType === 'pickupcall' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-user p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                    </div>
                ) : (item?.callType === 'spycall') && item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-headphones p-2 border-circle text-white"
                           style={{background: 'rgb(253, 166, 16)'}}></i>
                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                            <div className="border-circle relative"
                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                            </div>
                        </div>
                    </div>
                ) : item?.callType === 'spycall' && !item.isDeclined ? (
                    <div className="relative">
                        <i className="pi pi-headphones p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                    </div>
                ) : (
                    <div className="relative">
                        <i className="pi pi-question p-2 border-circle text-white bg-gray-500"
                           style={{width: '27.99px', height: '27.99px'}}></i>
                        <div className="absolute" style={{top: '30px', left: '0px', fontSize: '8px', color: '#666'}}>
                            {item?.callType || 'unknown'}
                        </div>
                    </div>
                );
    };

    const typeBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData?.ownerUserName}
                </span>
            </React.Fragment>
        );
    };

    const aniBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData?.ani || rowData?.aNI}
                </span>
            </React.Fragment>
        );
    };

    const aNumberBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData?.aNumber || rowData?.aNumber}
                </span>
            </React.Fragment>
        );
    };

    const typeOperatorTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData?.fullName}
                </span>
            </React.Fragment>
        );
    };


    const typeDirectionBodyTemplate = (rowData: DataRow) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData?.direction}
                </span>
            </React.Fragment>
        );
    };

    const campaignBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData?.campaignFullName}
                </span>
            </React.Fragment>
        );
    };

    const queueBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {rowData?.queueFullName}
                </span>
            </React.Fragment>
        );
    };

    const callResetBodyTemplate = (rowData: any) => {
        const foundCallReset = callResetDictionary?.filter((item: any) => item?.dictionaryId === rowData?.item?.callReset);
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {foundCallReset?.[0]?.name}
                </span>
            </React.Fragment>
        );
    };

    const amdHangupBodyTemplate = (rowData: any) => {
        const foundAmdHangup = forcedClosingDictionary?.filter((item: any) => item?.dictionaryId === rowData?.item?.forcedClosing);
        return (
            <React.Fragment>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {foundAmdHangup?.[0]?.name}
                </span>
            </React.Fragment>
        );
    };

    const renderStatusColumn = (rowData: any) => {
        let foundStatus = statusDictionary?.filter((status: any) => status?.dictionaryId === rowData?.item?.status);

        const statusMap: {
            [key: string]: string
        } = {
            101: 'p-badge status-active',
            103: 'p-badge status-success',
            104: 'p-badge status-unsuccessful',
            ACTION: 'p-badge status-action',
            102: 'p-badge status-processing'
        };

        const statusClass = statusMap[foundStatus?.[0]?.dictionaryId];

        return (
            <Badge value={foundStatus?.[0]?.name} className={`${statusClass} text-white customer-badge w-6 text-xs p-0`}
                   style={{maxWidth: '95px', minWidth: '95px'}}/>
        );
    };

    const directionFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть статус</div>
                <MultiSelect
                    filter
                    value={options.value}
                    optionValue="name"
                    options={queuesDirectoryDirectionType}
                    optionLabel="name"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"
                />
            </>
        );
    };

    const queueListWithId = campaignList?.queues?.map((queueData: any) => {
        return {
            ...queueData,
            queueWithId: `${queueData?.id} ${queueData?.name}`
        }
    });

    const queueFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть:</div>
                <MultiSelect
                    value={options.value}
                    optionValue="id"
                    selectedItemsLabel={options.value ? `Обрано: ${options.value.length}` : ""}
                    filter
                    options={queueListWithId}
                    maxSelectedLabels={0}
                    optionLabel="queueWithId"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter"

                />
            </>
        );
    };

    const typeChannelItemTemplate = (option: any) => {
        let statusName = callTypeDictionary?.map((item: any) => {
            if (item.name === option) {
                return item.description
            }
        })
        return (
            <div className="p-multiselect-representative-option">
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {statusName}
                </span>
            </div>
        );
    }

    const selectedTypeChannelTemplate = (option: any) => {
        let statusName = callTypeDictionary?.map((item: any) => {
            if (item.name === option) {
                return item.description
            }
        })
        if (option) {
            return (
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {statusName},
                </span>
            );
        }

        return "Оберіть тип";
    }

    const typeChannelFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть тип</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={callTypeDictionary?.map((item: { name: any; }) => item.name)}
                    itemTemplate={typeChannelItemTemplate}
                    selectedItemTemplate={selectedTypeChannelTemplate}
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter mb-3"
                />
            </>
        );
    };
    const ownerTypeFilterTemplate = (options: any) => {
        return (
            <>
                <div className="mb-3 text-bold">Оберіть тип</div>
                <MultiSelect
                    filter
                    value={options.value}
                    options={ownerTypeDictionary}
                    optionLabel="description"
                    optionValue="dictionaryId"
                    onChange={(e) => options.filterCallback(e.value, options.index)}
                    placeholder="нічого не обрано"
                    className="p-column-filter mb-3"
                />
            </>
        );
    };

    const BSessionIcon = () => {
        return <i className="pi pi-reply mr-2" style={{fontSize: '1rem', transform: 'rotate(270deg)'}}></i>
    }

    const convertSecondsToTime = (totalSeconds: number): string => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const contactNameBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <span style={{verticalAlign: 'middle'}} className="image-text">
                    {rowData?.pathSegment ?
                        <a target="_blank" className="mb-2" href={`${rowData?.pathSegment}?sessionId=${rowData?.sessionId}`}>{rowData?.contactName}</a> :
                        <p className="m-0 mb-2">{rowData?.contactName}</p>}
                    {/*{rowData?.contactName || '- - -'}*/}
                </span>
            </React.Fragment>
        );
    };


    const firstLevelTableCase = (name: string, i: number) => {
        let itemName: any;

        switch (name) {
            case "ani":
                itemName = <Column
                    key={i}
                    field="ani"
                    filterField="ani"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву клiента"
                    // filter
                    // filterElement={aniFilterTemplate}
                    body={aniBodyTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    bodyClassName={(rowData) => rowData?.isMatchingSessionId ? 'your-custom-class' : ''}
                    header={'Клiент'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "ownerUserName":
                itemName = <Column
                    key={i}
                    field="item.ownerUserName"
                    filterField="ownerUserName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву власника"
                    // filter
                    // filterElement={ownerFilterTemplate}
                    // filterClear={filterClearTemplate}
                    // filterApply={filterApplyTemplate}
                    header={'Власник дзвінка'}
                    body={typeBodyTemplate}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "aNumber":
                itemName = <Column
                    key={i}
                    field="aNumber"
                    filterField="aNumber"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть транк"
                    // filter
                    body={aNumberBodyTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    bodyClassName={(rowData) => rowData.item?.isMatchingSessionId ? 'your-custom-class' : ''}
                    header={'Транк'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "direction":
                itemName = <Column
                    field="direction"
                    key={i}
                    filterField="direction"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву оператора"
                    // filter
                    filterElement={directionFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    header={'Тип Активності'}
                    body={typeDirectionBodyTemplate}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "contactName":
                itemName = <Column
                    key={i}
                    // header={renderHeader('Реакція Оператора', 'ContactName')}
                    header="Контакт"
                    className="justify-content-start"
                    body={contactNameBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                    // sortable
                    // filterPlaceholder="Введіть час"
                    // filter
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="reactionOperator"
                />;
                break;
            case "queueFullName":
                itemName = <Column
                    field="item.queueId"
                    // sortable
                    key={i}
                    filterField="queueFullName"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть назву черги"
                    // filter
                    body={queueBodyTemplate}
                    filterElement={queueFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    // header={renderHeader('ID / Назва Черги', 'QueueId')}
                    header={'ID / Назва Черги'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "callType":
                itemName = <Column
                    field="callType"
                    header={'Активність'}
                    key={i}
                    filterField="callType"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть ID кампанії"
                    // filter
                    filterElement={typeChannelFilterTemplate}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    body={(rowData) => renderActivityColumn({item: rowData})}
                    filterMenuClassName={'filterStart'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "start":
                itemName = <Column
                    field="start"
                    filterField="start"
                    key={i}
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть ID кампанії"
                    // filter
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterMenuClassName={'filterStart'}
                    // header={renderHeader('Початок', 'Start')}
                    header={'Початок'}
                    body={(item:any) => formatDateTime(item?.start)}
                    // sortable
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                />;
                break;
            case "aNumber":
                itemName = <Column
                    key={i}
                    field="item.aNumber"
                    filterField="aNumber"
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterPlaceholder="Введіть транк"
                    body={aNumberBodyTemplate}
                    bodyClassName={(rowData) => rowData.item?.isMatchingSessionId ? 'your-custom-class' : ''}
                    header={'Транк'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "ownerType":
                let foundOwnerType = (ownerTypeId: any) => {
                    let ownerType = ownerTypeDictionary?.filter((status: any) => status?.dictionaryId === ownerTypeId);
                    return ownerType?.[0]?.description;
                }

                itemName = <Column
                    key={i}
                    header={'Тип власника'}
                    className="justify-content-start"
                    body={(data) => foundOwnerType(data?.ownerType) || ''}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                    filterPlaceholder="Виберіть власника"
                    headerStyle={{paddingTop: '10px'}}
                    showFilterMatchModes={false}
                    showFilterMenuOptions={false}
                    filterClear={filterClearTemplate}
                    filterApply={filterApplyTemplate}
                    filterField="ownerType"
                    filterElement={ownerTypeFilterTemplate}
                />;
                break;
            default:
                itemName = itemName = <Column
                    key={i}
                    className="justify-content-start"
                    header={renderHeader(`${itemName}`, '')}
                    body={'123'}
                />;
        }

        return itemName;
    }

    const secondLevelTableCase = (name: string, i: number) => {
        let itemName: any;
        switch (name) {
            case "ani":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="item.ani"
                    body={aniBodyTemplate}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "aNumber":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="item.aNumber"
                    body={aNumberBodyTemplate}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "ownerUserName":
                itemName = <Column
                    key={i}
                    field="ownerUserName"
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={typeBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "contactName":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="item.contactName"
                    body={contactNameBodyTemplate}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "fullName":
                itemName = <Column
                    key={i}
                    field="fullName"
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={typeOperatorTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "direction":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="direction"
                    headerClassName='hidden'
                    body={typeDirectionBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "campaignFullName":
                itemName = <Column
                    key={i}
                    className="justify-content-start"
                    field="campaignId"
                    headerClassName='hidden'
                    body={campaignBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "queueFullName":
                itemName = <Column
                    key={i}
                    field="queueId"
                    className="justify-content-start queue-column"
                    body={queueBodyTemplate}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '200px'}}
                />;
                break;
            case "status":
                itemName = <Column
                    key={i}
                    className="justify-content-start status-column"
                    field="status"
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                    body={renderStatusColumn}
                />;
                break;
            case "callType":
                itemName = <Column
                    key={i}
                    field="callType"
                    className="justify-content-start channel-column"
                    body={(rowData) => renderActivityColumn({item: rowData})}
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '150px'}}
                />;
                break;
            case "callResetName":
                itemName = <Column
                    key={i}
                    field="callResetName"
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={callResetBodyTemplate}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '160px'}}
                />;
                break;
            case "forcedClosing":
                itemName = <Column
                    key={i}
                    field="forcedClosing"
                    className="justify-content-start"
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '180px'}}
                    body={amdHangupBodyTemplate}
                />;
                break;
            case "start":
                itemName = <Column
                    key={i}
                    field="item.start"
                    className="justify-content-start"
                    sortable
                    headerClassName='hidden'
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                />;
                break;
            case "fullCallDuration":
                itemName = <Column
                    key={i}
                    header={'Тривалість дзвінка'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data.item.fullCallDuration && data?.item?.fullCallDuration !== -1 ? convertSecondsToTime(data?.item.fullCallDuration) : data?.item?.fullCallDuration === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "duration":
                itemName = <Column
                    key={i}
                    header={'Тривалість розмови'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data?.item?.duration && data?.item?.duration !== -1 ? convertSecondsToTime(data?.item?.duration) : data?.item?.duration === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "reactionClient":
                itemName = <Column
                    key={i}
                    header={'Реакція Клієнта'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data?.item?.reactionClient && data?.item?.reactionClient !== -1 ? convertSecondsToTime(data?.item?.reactionClient) : data?.item?.reactionClient === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "reactionOperator":
                itemName = <Column
                    key={i}
                    header={'Реакція Оператора'}
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={(data) => data?.item?.reactionOperator && data?.item?.reactionOperator !== -1 ? convertSecondsToTime(data?.item?.reactionOperator) : data?.item?.reactionOperator === 0 ? '00:00:00' : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '165px'}}
                />;
                break;
            case "ownerType":
                let foundOwnerType = (ownerTypeId: any) => {
                    let ownerType = ownerTypeDictionary?.filter((status: any) => status?.dictionaryId === ownerTypeId);
                    return ownerType?.[0]?.description;
                }

                itemName = <Column
                    key={i}
                    body={(data) => foundOwnerType(data?.item?.ownerType) || ''}
                    header={'Завершення'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}
                />;
                break;
            case "end":
                itemName = <Column
                    key={i}
                    header={'Завершення'}
                    headerClassName='hidden'
                    className="justify-content-start"
                    body={(data) => data?.item?.end ? formatDateTime(data?.item?.end) : '- - -'}
                    style={{cursor: 'pointer', width: `100%`, minWidth: '170px'}}

                />;
                break;
            default:
                itemName = itemName = <Column
                    key={i}
                    header={'Завершення'}
                    className="justify-content-start"
                    headerClassName='hidden'
                    body={''}
                />;
        }
    }

        const rowExpansionBSessionTemplate = (data: DataRow) => {
        return (
            <DataTable
                value={data?.children}
                className="p-datatable-customers monitoring-table monitoring-table-td monitoring-Expansion"
                selectionMode="single"
                rowClassName={dynamicBSessionRowClass}
                selection={selectedBSessionRowExpansion}
                onRowClick={(e) => {
                    setSelectedRowData(null);
                    if (!isMobile) {
                        if (props.profileMenuPin === true) {
                            setSelectedRowExpansion(e.data);
                            setVisible(true);
                        } else {
                            setSelectedRowExpansion(e.data);
                        }
                    } else {
                        setSelectedRowExpansion(e.data);
                        setVisible(true);
                    }
                }}
                dataKey="item.bSessionId"
            >
                <Column headerClassName={'hidden'} body={BSessionIcon}
                        style={{minWidth: '6rem', display: 'flex', alignItems: 'center', justifyContent: 'end'}}/>
                {selectedColumns && selectedColumns?.length &&
                    selectedColumns.sort((a: any, b: any) => a.order - b.order)
                        .map((col: any, i: number) => (
                            isColumnSelected(col.name) && secondLevelTableCase(col.name, i)
                        ))}
            </DataTable>
        );
    };

    const sessionBodyIcon = (rowData: any) => {
        if (rowData?.children?.length) {
            return <></>
        }
    }

    const rowExpansionTemplate = (data: DataRow) => {
        return (
            <DataTable
                value={data?.children}
                className="p-datatable-customers monitoring-table monitoring-table-td monitoring-Expansion"
                selectionMode="single"
                selection={selectedSessionRowExpansion}
                rowExpansionTemplate={rowExpansionBSessionTemplate}
                expandedRows={expandedSessionRows}
                onRowToggle={(e) => setExpandedSessionRows(e.data)}
                onRowClick={(e) => {
                    dispatch(getEventMonitorToUserDetail(e.data.item.id, jwtToken?.jwtToken));
                    setSelectedRowData(null);
                    if (!isMobile) {
                        if (props.profileMenuPin === true) {
                            setSelectedRowExpansion(e.data);
                            setVisible(true);
                        } else {
                            setSelectedRowExpansion(e.data);
                        }
                    } else {
                        setSelectedRowExpansion(e.data);
                        setVisible(true);
                    }
                }}
                dataKey="item.bSessionId"
            >
                <Column rowReorderIcon={'pi pi-close'} headerClassName={'hidden'} expander={allowExpansion}
                        style={{minWidth: '4rem', display: 'flex', alignItems: 'center', justifyContent: 'end'}}/>
                <Column headerClassName={'hidden'} body={sessionBodyIcon} expander={allowExpansion}
                        style={{minWidth: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'center'}}/>
                {selectedColumns && selectedColumns?.length &&
                    selectedColumns?.sort((a: any, b: any) => a.order - b.order)
                        .map((col: any, i: number) => (
                            isColumnSelected(col?.name) && secondLevelTableCase(col?.name, i)
                        ))}
            </DataTable>
        );
    };

    const allowExpansion = (rowData: DataRow) => {
        return rowData.children?.length || false;
    };

    const dynamicRowClass = (data: any) => {
        if (data?.callDetailId === selectedRowData?.callDetailId) {
            return 'mainRowMonitoringTable p-highlight';
        }
        return 'mainRowMonitoringTable';
    };

    const dynamicBSessionRowClass = () => {
        return 'BSessionRow';
    };

    const isColumnSelected = (columnName: string) => {
        return selectedColumns?.some((item: { name: string }) => item?.name === columnName);
    };

    const headerDialogBody = () => {
        return <div className="flex justify-content-start align-items-start" >
            {/*<button className="close-button block cursor-pointer ml-0"*/}
            {/*        onClick={() => {*/}
            {/*            copyDetailsLink();*/}
            {/*        }*/}
            {/*        }><span className="pi pi-copy"></span>*/}
            {/*</button>*/}
            {/*{!props.isWindow && <button className="close-button block cursor-pointer ml-2"*/}
            {/*                            onClick={() => {*/}
            {/*                                openDetailsLink();*/}
            {/*                            }*/}
            {/*                            }><span className="pi pi-arrow-up-right-and-arrow-down-left-from-center"></span>*/}
            {/*</button>}*/}
        </div>
    }
    const renderTable = () => {
        return (
            <div className="layout-dashboard">
                <div className="flex flex-wrap col-12 md:col-12">
                    <div
                        className={classNames('card widget-table mr-4 col-12 transition-duration-300 monitoring-table align-self-start monitoringLoader', {'': (selectedRowData || selectedRowExpansion) && !isMobile(), 'md:col-12': !(selectedRowData || selectedRowExpansion)})}>
                        <MonitoringQueueNav countActiveCalls={queueMonitorStats?.countActiveCalls} toggleButtonActivity={toggleButtonActivity} setToggleButtonActivity={setToggleButtonActivity} setActivity={setActivity} activity={activity} userSortFields={userSortFields?.fields}
                                           resetSorting={handleReset} toggleTab={toggleTab}
                                           activeTab={activeTab}/>
                        <DataTable
                            expandedRows={expandedRows}
                            onRowToggle={(e) => setExpandedRows(e.data)}
                            rowExpansionTemplate={rowExpansionTemplate}
                            scrollable
                            scrollHeight={(selectedRowData || selectedRowExpansion) && !isMobile() ? '40vh' : '70vh'}
                            ref={dataTableRef}
                            rows={10}
                            onSort={monitoringSort}
                            filters={clearFilters}
                            loading={loader}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            value={monitoringList}
                            className="p-datatable-customers monitoring-table monitoring-table-rowGroup"
                            rowClassName={dynamicRowClass}
                            selectionMode="single"
                            emptyMessage="Нічого не знайдено"
                            rowHover={false}
                            onFilter={customFilter}
                            lazy
                            onRowClick={(e) => {
                                setSelectedRowExpansion(null);
                                if (!isMobile) {
                                    if (props.profileMenuPin === true) {
                                        setSelectedRowData(e.data);
                                        setVisible(true);
                                    } else {
                                        setSelectedRowData(e.data);
                                    }
                                } else {
                                    setSelectedRowData(e.data);
                                    setVisible(true);
                                }
                            }} dataKey="callDetailId"
                        >
                            <Column rowReorderIcon={'pi pi-close'} expander={allowExpansion}
                                    style={{minWidth: '6rem'}}/>
                            {selectedColumns && selectedColumns?.length &&
                                selectedColumns?.sort((a: any, b: any) => a.order - b.order)
                                    .map((col: any, i: number) => (
                                        isColumnSelected(col?.name) && firstLevelTableCase(col?.name, i)
                                    ))}
                        </DataTable>
                    </div>
                    {(selectedRowData || selectedRowExpansion) && (
                        <>
                            {windowWidth > 1248 && <div
                                className={classNames('card widget-table col-12 md:col-12 align-self-start sticky top-0')}>
                                <MonitoringQueueDetails selectedRowData={selectedRowData} setSelectedRowData={setSelectedRowData}
                                                       setSelectedRowExpansion={setSelectedRowExpansion}
                                                       />
                            </div>}

                            {windowWidth <= 1248 && <div>
                                <Dialog visible={visible} header={headerDialogBody} className="monitoring-info" onHide={() => setVisible(false)}>
                                    <MonitoringQueueDetails selectedRowData={selectedRowData} setSelectedRowData={setSelectedRowData}
                                                           setSelectedRowExpansion={setSelectedRowExpansion}
                                    />
                                </Dialog>
                            </div>}
                        </>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div>
            {renderTable()}
        </div>
    );
};

export default MonitoringQueue;
